import { useLang } from "../../lib/lang";
import { LogoMark } from "./Logo";

export const Marquee = () => {
  const { t } = useLang();
  const row = [...t.marquee, ...t.marquee];
  return (
    <div data-testid="editorial-marquee" className="relative border-y border-white/10 bg-[#0D1124] py-6 lg:py-8 overflow-hidden">
      <div className="flex w-max animate-marquee">
        {[0, 1].map((k) => (
          <div key={k} className="flex shrink-0 items-center" aria-hidden={k === 1}>
            {row.map((w, i) => (
              <span key={`${k}-${i}`} className="flex items-center">
                <span className={`font-display uppercase text-4xl lg:text-7xl whitespace-nowrap px-6 lg:px-10 ${i % 2 ? "text-outline-violet" : "text-white"}`}>{w}</span>
                <LogoMark className="w-8 h-8 lg:w-12 lg:h-12 shrink-0" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
